import { FC, useMemo } from 'react';
import { Select, SelectProps } from 'antd';

import { GenderType } from '@/shared/types/enums';

export const SelectGender: FC<SelectProps> = ({ placeholder, ...props }) => {
  const options = useMemo(() => {
    return list.map((group) => ({ value: group, label: i18nMap[group] }));
  }, []);

  return <Select placeholder={placeholder ?? 'Select Gender'} options={options} {...props} />;
};

const list = [GenderType.MALE, GenderType.FEMALE, GenderType.OTHER];

// TODO i18n
const i18nMap = {
  [GenderType.MALE]: 'Male',
  [GenderType.FEMALE]: 'Female',
  [GenderType.OTHER]: 'Other',
};
